<template>
  <tr>
    <td>
      <b-field>
          <b-input v-model="row.fileName" placeholder="Введите название документа" @change="handleUpdate" />
      </b-field>
      <input type="file" id='photo' @change='loadFile' hidden ref="loadFile"/>
      <span class="link" @click="handleloadFile" v-if="!row.file">
        Загрузить документ
      </span>
      <span v-else>
        <span class="link">{{row.file | path }}</span>
        <span class="delete-document" @click="deleteFile()">X</span>
      </span>
    </td>
    <td>
      <el-date-picker
        type="date"
        v-model="date"
        :editable="false"
        @change="dateUpdated"
        >
      </el-date-picker>
    </td>
    <td>
      <el-date-picker
        @change="dateUpdated"
        v-model="startDate"
        :editable="false"
        type="date">
      </el-date-picker>
      —
      <el-date-picker
        type="date"
        :editable="false"
        v-model="endDate"
        @change="dateUpdated"
        >
      </el-date-picker>
    </td>
    <td>
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteRequiredInformationBookkeeping(row)"/>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BankRequirementRow',
  data () {
    return {
      updateTimer: null,
      date: '',
      startDate: '',
      endDate: ''
    }
  },
  props: {
    row: {
      required: true
    }
  },
  created () {
    this.date = this.row.disclosureDate
    this.startDate = this.row.startDate
    this.endDate = this.row.endDate
  },
  methods: {
    ...mapActions(['deleteRequiredInformationBookkeeping', 'updateRequiredInformationBookkeeping',
      'loadDisclosureInformationBookkeepinfFile', 'deleteDisclosureInformationBookkeepinfFile']),
    handleUpdate () {
      this.updateRequiredInformationBookkeeping(this.row)
    },
    dateUpdated () {
      this.row.disclosureDate = this.date
      this.row.startDate = this.startDate
      this.row.endDate = this.endDate
      this.handleUpdate()
    },
    loadFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('document', file)
      this.row.newFile = formData
      this.row.file = file.name
      this.handleUpdate()
      this.$forceUpdate()
    },
    deleteFile () {
      delete this.row.newFile
      this.row.file = ''
      this.handleUpdate()
      this.$forceUpdate()
    },
    handleloadFile () {
      this.$refs.loadFile.click()
    }
  },
  filters: {
    path (path) {
      return path.split('/').pop()
    }
  }
}
</script>

<style scoped>
.delete-icon {
  height: 24px;
  min-width: 24px;
  position: initial;
}
td {
  padding: 4px 12px 4px 0;
}
.delete-document {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// BankRequirementBookkeeping.vue?e75e2adc